export default class FTPlayerOptions {
  hls = {}; //hls settings options to be passed for the hls.js
  dash = {
      robustnessLevel: null
  }; //dash settings options to be passed for
  onError = null;
  useNative = false;
  startTime = 0;
}
